"use client";
import React from "react";
import styles from "./CouponErrorModal.module.scss";

export default function CouponErrorModal({
    open,
    onClose,
    statusCode,
    genericMessage,
    title: titleOverride = undefined,
}) {
    if (!open) return null;

    // Odredi title/message po statusu; genericMessage koristi se samo u default grani
    let title = titleOverride || "Coupon error";
    let message = "Something went wrong while applying your coupon.";

    if (statusCode === 200) {
        title = titleOverride || "Coupon applied";
        message = "Coupon successfully redeemed.";
    } else if (statusCode === 409) {
        title = titleOverride || "Coupon conflict";
        message =
            "This bonus can’t be applied right now. It’s usually because the coupon was already redeemed, isn’t allowed for your account, or you currently have an active balance.";
    } else if (statusCode === 429) {
        title = titleOverride || "Too many attempts";
        message =
            "You’ve made too many attempts in a short time. Please wait a few minutes and try again.";
    } else if (genericMessage) {
        // samo za ostale statuse prikaži poruku sa servera/axios-a
        message = genericMessage;
    }

    const openSupport = () => {
        try {
            if (typeof window !== "undefined" && window.Tawk_API?.maximize) {
                window.Tawk_API.maximize();
            } else {
                window.location.href = `mailto:${process.env.NEXT_PUBLIC_SUPPORT_EMAIL || "support@yourcasino.com"}?subject=Coupon%20issue%20(${statusCode || "N/A"})`;
            }
        } catch (_) {
            window.location.href = `mailto:${process.env.NEXT_PUBLIC_SUPPORT_EMAIL || "support@yourcasino.com"}?subject=Coupon%20issue%20(${statusCode || "N/A"})`;
        }
    };

    return (
        <div className={styles.backdrop} role="dialog" aria-modal="true">
            <div className={styles.modal}>
                <header className={styles.header}>
                    <h3>{title}</h3>
                    <button className={styles.close} onClick={onClose} aria-label="Close">×</button>
                </header>

                <div className={styles.body}>
                    <p>{message}</p>
                    {/* {statusCode && statusCode !== 200 && (
                        <p className={styles.hint}>
                            Error code: <b>{statusCode}</b>
                        </p>
                    )} */}
                    {statusCode === 409 && (
                        <p className={styles.hintSmall}>
                            Please contact support and we’ll sort it out for you.
                        </p>
                    )}
                    {statusCode === 200 && (
                        <p className={styles.hintSmall}>
                            You can now continue playing or check your balance.
                        </p>
                    )}
                </div>

                <div className={styles.actions}>
                    {statusCode === 409 ? (
                        <button className={styles.primary} onClick={openSupport}>
                            Contact Support
                        </button>
                    ) : null}
                    <button className={styles.secondary} onClick={onClose}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
}
